import React from 'react';
import WhatsappCTA from '../components/WhatsappCTA';
import Carousel from '../components/Carousel';
import dummy1 from '../assets/Vista/dummy1.jpg';
import dummy2 from '../assets/Vista/dummy2.jpg';
import dummy3 from '../assets/Vista/dummy3.jpg';
import '../styles/SoldOut.css';

const translations = {
  en: {
    title: "Vista Verde Residencial",
    subtitle: "Where River Meets Ocean, and Nature Meets Opportunity",
    p1: "Discover Vista Verde Residencial, an exceptional collection of 58 premium lots nestled in a breathtaking natural sanctuary. Here, the tranquil beauty of a winding river converges with the allure of the Pacific, offering residents unparalleled views that stretch from verdant riverbanks to the shimmering expanse of beach – a mere 1.2 km away.",
    p2: "Imagine waking to panoramic vistas, where the serenity of nature blends seamlessly with the vibrant energy of the coast. Vista Verde Residencial is more than just a place to build a home; it's an invitation to co-live harmoniously with the surrounding environment, a natural haven where tranquility reigns. This is a promising investment opportunity, as this developing area offers exceptional value, allowing you to secure a prime location before prices surge.",
    p3: "Don't miss your chance to own a piece of paradise where stunning views and natural beauty meet the promise of future growth.",
    button: "Book",
    includes: "This Lot Includes:",
    includesp1: "Property Regimen Declaration: 'Bienes Comunales'",
    includesp2: "Water: Still Pending...",
    includesp3: "Electricity: Still Pending...",
    includesp4: "Amenities: No Amenities, but green area space"
  },
  es: {
    title: "Vista Verde Residencial",
    subtitle: "Donde el Río Encuentra el Océano y la Naturaleza Encuentra la Oportunidad",
    p1: "Descubre Vista Verde Residencial, una excepcional colección de 58 lotes premium ubicados en un impresionante santuario natural. Aquí, la belleza tranquila de un río serpenteante converge con el encanto del Pacífico, ofreciendo a los residentes vistas incomparables que se extienden desde las riberas verdes hasta la brillante extensión de la playa, a solo 1.2 km de distancia.",
    p2: "Imagina despertar con vistas panorámicas, donde la serenidad de la naturaleza se fusiona perfectamente con la energía vibrante de la costa. Vista Verde Residencial es más que un lugar para construir una casa; es una invitación a convivir en armonía con el entorno, un refugio natural donde reina la tranquilidad. Esta es una oportunidad de inversión prometedora, ya que esta área en desarrollo ofrece un valor excepcional, permitiéndote asegurar una ubicación privilegiada antes de que aumenten los precios.",
    p3: "No pierdas la oportunidad de poseer un pedazo de paraíso donde las vistas impresionantes y la belleza natural se encuentran con la promesa de crecimiento futuro.",
    button: "Reservar",
    includes: "Este Lote Incluye:",
    includesp1: "Propiedad: 'Bienes Comunales'",
    includesp2: "Uso de agua: Sigue Pendiente...",
    includesp3: "Instalaciones: Sigue Pendiente...",
    includesp4: "Amenindades: No tiene amenidades, área verde designada"
  }
};

const Vista = ({ language }) => {
  return (
    <div className="testimonial">
      <div className="testimonial-text">
        <h1>{translations[language].title}</h1>
        
        <Carousel 
          image1={dummy1} 
          image2={dummy2}
          image3={dummy3}
        />
        
        <h2>{translations[language].subtitle}</h2>
        <p>{translations[language].p1}</p>
        <p>{translations[language].p2}</p>
        <p>{translations[language].p3}</p>


        <h2>{translations[language].includes}</h2>
        <div className="callout-box">
        <p>📍 {translations[language].includesp1} </p>
        <p>📍 {translations[language].includesp2}  </p>
        <p>📍 {translations[language].includesp3}  </p>
        <p>📍 {translations[language].includesp4}  </p>
        </div>
        
        <WhatsappCTA language={language}/>
      </div>
    </div>
  );
};

export default Vista;